"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationJourney',
  data: function data() {
    return {
      loading: false,
      list: [],
      behaviorType: ''
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      var params = {
        page: 1,
        limit: 50
      };
      if (this.behaviorType) params.behaviorType = this.behaviorType;
      (0, _decoration.decorationBehaviorListApi)(params).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};